// extracted by mini-css-extract-plugin
export var pageFeatureDetail = "ContentfulBlockFeatureDetail-module--pageFeatureDetail--onrny";
export var subtitle = "ContentfulBlockFeatureDetail-module--subtitle--k89ro";
export var features = "ContentfulBlockFeatureDetail-module--features--1C-Ip";
export var featuresImg = "ContentfulBlockFeatureDetail-module--featuresImg--uK2q9";
export var featuresItems = "ContentfulBlockFeatureDetail-module--featuresItems--AhK+B";
export var collapseWrapper = "ContentfulBlockFeatureDetail-module--collapseWrapper--lkde3";
export var collapseBody = "ContentfulBlockFeatureDetail-module--collapseBody--awZ4m";